import { IMAGE_POSITIONS, normalizeImagePosition } from "@/lib/api";

export default function ImagePositionPicker({ value, onChange, testid, compact = false }) {
  const selected = normalizeImagePosition(value);

  return (
    <div className={compact ? "mt-2" : "mt-3"} data-testid={testid}>
      {!compact && <p className="mb-1.5 text-[10px] font-bold uppercase tracking-widest text-slate-500">Posisi Gambar</p>}
      <div className="inline-flex rounded-md border border-slate-300 bg-slate-50 p-0.5" role="group" aria-label="Pilih posisi gambar">
        {IMAGE_POSITIONS.map((position) => (
          <button
            key={position.value}
            type="button"
            onClick={() => onChange(position.value)}
            data-testid={testid ? `${testid}-${position.value}` : undefined}
            aria-pressed={selected === position.value}
            className={`${compact ? "px-2 py-1 text-[10px]" : "px-3 py-1.5 text-xs"} rounded font-bold transition-colors ${selected === position.value ? "bg-[#0B1F3A] text-white shadow-sm" : "text-slate-500 hover:text-[#0B1F3A]"}`}
          >
            {position.label}
          </button>
        ))}
      </div>
    </div>
  );
}
